"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClientTradingTokenManager = void 0;
const rxjs_1 = require("rxjs");
const trade_utils_lib_1 = require("trade_utils_lib");
const interface_1 = require("../interface");
const errors_1 = require("../interface/errors");
class ClientTradingTokenManager extends interface_1.BaseTokenManager {
    constructor() {
        super(...arguments);
        this.currentRequest = null;
    }
    requestTradingTokenPromise(key, subscriber) {
        return __awaiter(this, void 0, void 0, function* () {
            const subscribers = [subscriber];
            this.currentRequest = { subscribers };
            try {
                const accessToken = yield (0, rxjs_1.firstValueFrom)((0, trade_utils_lib_1.getTradeDependencyInstance)().getAccessToken(this.consumeForceUpdateAccessToken()));
                if (!accessToken) {
                    throw errors_1.ErrorNotGetAccessToken;
                }
                const rsaPublicKey = yield (0, rxjs_1.firstValueFrom)((0, trade_utils_lib_1.getTradeDependencyInstance)().getRSAPublicKey());
                const aesKey = (0, trade_utils_lib_1.random32String)();
                const tokenInfo = yield (0, rxjs_1.firstValueFrom)(trade_utils_lib_1.Network.post({
                    url: `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().manageApiHost}/trade_token/`,
                    data: { secret: (0, trade_utils_lib_1.encryptWithRSAKey)(rsaPublicKey, aesKey) },
                    headers: { Authorization: `Bearer ${accessToken}` },
                }))
                    .then((data) => {
                    var _a, _b, _c;
                    const expire_at_arr = [(_a = data.spot) === null || _a === void 0 ? void 0 : _a.expire_at, (_b = data.swap) === null || _b === void 0 ? void 0 : _b.expire_at, (_c = data.trader) === null || _c === void 0 ? void 0 : _c.expire_at].filter((e) => Number(e) > 0);
                    const expire_at = Math.min(...expire_at_arr);
                    const tradingTokenInfo = {
                        id: key,
                        apiSecret: (0, trade_utils_lib_1.decryptApiSecret)(data.spot.api_secret, aesKey),
                        tradingToken: data.spot.token,
                        awsToken: accessToken,
                        swapApiSecret: data.swap && data.swap.api_secret ? (0, trade_utils_lib_1.decryptApiSecret)(data.swap.api_secret, aesKey) : "",
                        swapToken: data.swap ? data.swap.token : "",
                        traderToken: data.trader ? data.trader.token : "",
                        traderApiSecret: data.trader ? (0, trade_utils_lib_1.decryptApiSecret)(data.trader.api_secret, aesKey) : "",
                        tokenExpire: expire_at,
                    };
                    return tradingTokenInfo;
                })
                    .catch((error) => {
                    if ((error === null || error === void 0 ? void 0 : error.code) === 40101612) {
                        //{
                        // 	"code": 40101612,
                        // 	"message": "Invalid token: this token has been revoked",
                        // 	"data": null
                        // }
                        this.updateAccessToken();
                    }
                    const empty = {
                        id: "default",
                        apiSecret: "",
                        tradingToken: "",
                        awsToken: accessToken,
                        swapApiSecret: "",
                        swapToken: "",
                        tokenExpire: 0,
                    };
                    return empty;
                });
                if (tokenInfo.tradingToken) {
                    this.updateTokenCacheResult(key, tokenInfo);
                }
                for (const subscriber of subscribers) {
                    subscriber.next(tokenInfo);
                    subscriber.complete();
                }
            }
            catch (error) {
                for (const subscriber of subscribers) {
                    subscriber.error(error);
                    subscriber.complete();
                }
            }
            this.currentRequest = null;
        });
    }
    requestTradingBotTokenImpl(key) {
        return new rxjs_1.Observable((subscriber) => {
            if (this.currentRequest) {
                this.currentRequest.subscribers.push(subscriber);
            }
            else {
                this.requestTradingTokenPromise(key, subscriber).catch((error) => {
                    (0, trade_utils_lib_1.getTradeDependencyInstance)().log(trade_utils_lib_1.LogLevel.LEVEL_ERROR, "ClientTradingTokenManager", error);
                });
            }
        });
    }
}
exports.ClientTradingTokenManager = ClientTradingTokenManager;
